import React, { useEffect, useRef, useState } from 'react';
import { Search, X } from 'lucide-react';
import { bodasApi } from '../bodasUtils';

// Primero los nombres que empiezan por lo escrito
const ordenar = (lista, texto) => {
  const q = texto.trim().toLowerCase();
  const pos = (c) => Number(!(c.nombre || '').toLowerCase().startsWith(q));
  return [...lista].sort((a, b) => pos(a) - pos(b));
};

export default function BuscadorCliente({ seleccionado, onSeleccionar, label = 'Cliente', ayuda, testId = 'buscador-cliente' }) {
  const [texto, setTexto] = useState('');
  const [resultados, setResultados] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const ultimo = useRef(0);

  useEffect(() => {
    if (texto.trim().length < 2) { setResultados([]); return undefined; }
    const marca = ++ultimo.current;
    const t = setTimeout(() => {
      bodasApi.buscarClientes(texto.trim())
        .then(r => { if (marca === ultimo.current) { setResultados(ordenar(r, texto)); setAbierto(true); } })
        .catch(() => setResultados([]));
    }, 300);
    return () => clearTimeout(t);
  }, [texto]);

  const elegir = (c) => { onSeleccionar(c); setTexto(''); setResultados([]); setAbierto(false); };

  return (
    <div className="block">
      <span className="text-sm font-medium text-slate-700">{label}</span>
      {seleccionado ? (
        <div className="mt-1 flex items-center justify-between gap-3 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2.5" data-testid={`${testId}-seleccionado`}>
          <span className="min-w-0 truncate text-sm text-emerald-900"><strong>{seleccionado.nombre}</strong>{seleccionado.id_cliente && <span className="text-emerald-700"> · {seleccionado.id_cliente}</span>}</span>
          <button type="button" onClick={() => onSeleccionar(null)} className="rounded p-1 text-emerald-800 hover:bg-emerald-100" aria-label="Quitar cliente" data-testid={`${testId}-quitar`}><X className="h-4 w-4" /></button>
        </div>
      ) : (
        <div className="relative mt-1">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input value={texto} onChange={e => setTexto(e.target.value)} onFocus={() => resultados.length && setAbierto(true)} placeholder="Buscar por nombre, documento, correo o teléfono"
            className="w-full rounded-lg border border-slate-300 bg-white py-2.5 pl-9 pr-3 text-base outline-none focus:border-emerald-700 focus:ring-2 focus:ring-emerald-700/20 sm:text-sm" data-testid={`${testId}-input`} />
          {abierto && resultados.length > 0 && (
            <ul className="absolute z-20 mt-1 max-h-64 w-full overflow-auto rounded-lg border border-slate-200 bg-white py-1 shadow-lg" data-testid={`${testId}-resultados`}>
              {resultados.map(c => (
                <li key={c.id}>
                  <button type="button" onClick={() => elegir(c)} className="block w-full px-3 py-2 text-left text-sm hover:bg-slate-50" data-testid={`${testId}-opcion-${c.id_cliente || c.id}`}>
                    <span className="font-medium text-slate-800">{c.nombre}</span>
                    <span className="block text-xs text-slate-500">{[c.id_cliente, c.telefono, c.correo].filter(Boolean).join(' · ')}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      {ayuda && <span className="mt-1 block text-xs text-slate-500">{ayuda}</span>}
    </div>
  );
}
